import { render, staticRenderFns } from "./getBonafideCertificateVvpPrint.vue?vue&type=template&id=fbb83a26&scoped=true&"
import script from "./getBonafideCertificateVvpPrint.vue?vue&type=script&lang=js&"
export * from "./getBonafideCertificateVvpPrint.vue?vue&type=script&lang=js&"
import style0 from "./getBonafideCertificateVvpPrint.vue?vue&type=style&index=0&id=fbb83a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb83a26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VRow,VSnackbar})
